import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import * as AdminActions from "../../../../actions/admin";

export const defaultState = {
    Pointsystem: '0',
    SportDdB_L: '0',
    SportDdB_M: '0',
    SportDdB: '0',
    SportSektion: '0',
    SportForening: '0',
    MaxDM_marathon: '0',
    MaxDM_lang: '0',
    MaxDM_mellem: '0',
    Hastighed9192: '0',
    HastighedAndre: '0',
    MaxRegTidDiff: '0',
};

class SettingsMarkings extends React.Component {

    static propTypes = {
        editMode: PropTypes.bool.isRequired,
        section: PropTypes.object.isRequired,
        sectionNo: PropTypes.string.isRequired,
        isDDB: PropTypes.bool.isRequired,
        isSection: PropTypes.bool.isRequired,
        isClub: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        editMode: false,
    };

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.getStateFromStore(props));
    }

    componentWillReceiveProps(nextProps) {
        if(!nextProps.editMode || ((nextProps.section === null && this.props.section !== null) || (nextProps.section !== null && (this.props.section === null || this.props.sectionNo !== nextProps.sectionNo)))) this.setState(this.getStateFromStore(nextProps));
    }

    getStateFromStore(props) {
        if (props.section.Markering === null)
            return defaultState;
        else {
            const marking = props.section.Markering;
            let stateFromStore = {
                Pointsystem: marking.Pointsystem === null ? '0' : marking.Pointsystem.toString(),
                SportDdB_L: marking.SportDdB_L === null ? '0' : marking.SportDdB_L.toString(),
                SportDdB_M: marking.SportDdB_M === null ? '0' : marking.SportDdB_M.toString(),
                SportDdB: marking.SportDdB === null ? '0' : marking.SportDdB.toString(),
                SportSektion: marking.SportSektion === null ? '0' : marking.SportSektion.toString(),
                SportForening: marking.SportForening === null ? '0' : marking.SportForening.toString(),
                MaxDM_marathon: marking.MaxDM_marathon === null ? '0' : marking.MaxDM_marathon.toString(),
                MaxDM_lang: marking.MaxDM_lang === null ? '0' : marking.MaxDM_lang.toString(),
                MaxDM_mellem: marking.MaxDM_mellem === null ? '0' : marking.MaxDM_mellem.toString(),
                Hastighed9192: marking.Hastighed9192 === null ? '0' : marking.Hastighed9192.toString().replace('.',','),
                HastighedAndre: marking.HastighedAndre === null ? '0' : marking.HastighedAndre.toString().replace('.',','),
            }
            if(props.isDDB){
                stateFromStore.MaxRegTidDiff =  props.section.MaxRegTidDiff === null ? 0 : props.section.MaxRegTidDiff.toString()
            }
            return stateFromStore;
        }
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    save = (onSuccess = null) => {
        if (this.allInputValid()) {
            const entity = Object.assign({}, {
                Pointsystem: this.state.Pointsystem === 0 ? null : Number(this.state.Pointsystem),
            }, this.props.isDDB ? {
                SportDdB_L: this.state.SportDdB_L === 0 ? null : Number(this.state.SportDdB_L),
                SportDdB_M: this.state.SportDdB_M === 0 ? null : Number(this.state.SportDdB_M),
                SportDdB: this.state.SportDdB === 0 ? null : Number(this.state.SportDdB),
                MaxDM_marathon: this.state.MaxDM_marathon === 0 ? null : Number(this.state.MaxDM_marathon),
                MaxDM_lang: this.state.MaxDM_lang === 0 ? null : Number(this.state.MaxDM_lang),
                MaxDM_mellem: this.state.MaxDM_mellem === 0 ? null : Number(this.state.MaxDM_mellem),
                MaxRegTidDiff: this.state.MaxRegTidDiff === 0 ? null : Number(this.state.MaxRegTidDiff),
            } : null, this.props.isDDB || this.props.isSection ? {
                SportSektion: this.state.SportSektion === 0 ? null : Number(this.state.SportSektion),
                Hastighed9192: this.state.Hastighed9192 === 0 ? null : Number(this.state.Hastighed9192.replace(',', '.')),
                HastighedAndre: this.state.HastighedAndre === 0 ? null : Number(this.state.HastighedAndre.replace(',', '.')),
            } : null, this.props.isClub ? {
                SportForening: this.state.SportForening === 0 ? null : Number(this.state.SportForening),
            } : null);

            if(this.props.section.Markering === null){
                this.props.dispatch(AdminActions.createMarking(this.props.isDDB ? 'ddb' : this.props.isSection ? this.props.section.Sektionsnr : this.props.section.Foreningsnr, entity, onSuccess))
            } else {
                this.props.dispatch(AdminActions.updateMarking(this.props.isDDB ? 'ddb' : this.props.isSection ? this.props.section.Sektionsnr : this.props.section.Foreningsnr, entity, onSuccess));
            }
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }

    fields = [];
    render() {
        const editMode = this.props.editMode
        return <div className={"form-page settings-markings " + (editMode ? "editable" : "read-only")}>
            <div className={'content'}>
                <div className={'block-content'}>
                    <div>
                        <label className={'header'}>Pointsberegningssystem</label>
                    </div>
                    <div className={'points'}>
                        <UserFieldElement
                            dataType={UserFieldDataType.options}
                            className=""
                            containerClassName="display-inline-block"
                            disabled={!this.props.editMode}
                            name="Pointsystem"
                            id="Pointsystem"
                            value={this.state.Pointsystem}
                            options={[
                                {key: '0', value: '1000-points', disabled: !this.props.editMode},
                                {key: '1', value: 'Placeringspoint', disabled: !this.props.editMode},
                            ]}
                            autoCheckErrors={true}
                            required={false}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={e => {
                                this.setState({Pointsystem: e.target.value});
                            }}
                            ref={instance => { this.fields[0] = instance; }}
                        />
                        {/*<span className="pool-prices">
                            <span className="pool-prices-option">
                                <input id="PuljePuljepraemier" name="PuljePuljepraemier" type="checkbox" checked={this.state.Pointsystem}
                                       disabled={!this.props.editMode} onChange = {this.onPoolPriceClick}/>
                                <label htmlFor="PuljePuljepraemier" className={!this.props.editMode ? 'disabled' : ''}>1000-points</label>
                            </span>
                            <span className="pool-prices-option">
                                <input id="ElitePuljepraemier" name="ElitePuljepraemier" type="checkbox" checked={this.state.ElitePuljepraemier}
                                       disabled={!this.props.editMode} onChange = {this.onPoolPriceClick}/>
                                <label htmlFor="ElitePuljepraemier" className={!this.props.editMode ? 'disabled' : ''}>Placeringspoint</label>
                            </span>
                        </span>*/}
                    </div>
                </div>
            </div>
            <div className={'content no-border'}>
                <div className={'block-content'}>
                    <table className="main-form-table num-of-pigeons">
                        <tbody>
                        <tr>
                            <td className={"label-cell"}></td>
                            <td className={"label-cell"}><span className="label-text"><label htmlFor="SportDdB_L">Ddb lang</label></span></td>
                            <td className={"label-cell"}><span className="label-text"><label htmlFor="SportDdB_M">Ddb mellem</label></span></td>
                            <td className={"label-cell"}><span className="label-text"><label htmlFor="SportDdB">Ddb land</label></span></td>
                            <td className={"label-cell"}><span className="label-text"><label htmlFor="SportSektion">Sektion</label></span></td>
                            {this.props.isClub ? <td className={"label-cell"}><span className="label-text"><label htmlFor="SportForening">Forening</label></span></td> : null}
                        </tr>
                        <tr className="normal-row">
                            <td className={"topic-cell"}><span className="label-text"><label>Antal sportsduer for:</label></span></td>
                            <td className={"data-cell"}>
                                {editMode && this.props.isDDB ?
                                    <UserFieldElement
                                        dataType={UserFieldDataType.int}
                                        placeholder=""
                                        className="field-1 very-small-field"
                                        containerClassName="display-inline-block"
                                        name="SportDdB_L"
                                        id="SportDdB_L"
                                        value={this.state.SportDdB_L}
                                        autoCheckErrors={true}
                                        required={false}
                                        hideErrWhenFocused={true}
                                        hideErrUntilFocused={true}
                                        onChange={this.onStandardFieldChange}
                                        ref={instance => { this.fields[1] = instance; }}
                                    />
                                    : <span className="value-text">{this.props.isDDB ? this.state.SportDdB_L : this.props.admin.generalSection.Markering.SportDdB_L}</span>}
                            </td>
                            <td className={"data-cell"}>
                                {editMode && this.props.isDDB ?
                                    <UserFieldElement
                                        dataType={UserFieldDataType.int}
                                        placeholder=""
                                        className="field-1 very-small-field"
                                        containerClassName="display-inline-block"
                                        name="SportDdB_M"
                                        id="SportDdB_M"
                                        value={this.state.SportDdB_M}
                                        autoCheckErrors={true}
                                        required={false}
                                        hideErrWhenFocused={true}
                                        hideErrUntilFocused={true}
                                        onChange={this.onStandardFieldChange}
                                        ref={instance => { this.fields[2] = instance; }}
                                    />
                                    : <span className="value-text">{this.props.isDDB ? this.state.SportDdB_M : this.props.admin.generalSection.Markering.SportDdB_M}</span>}
                            </td>
                            <td className={"data-cell"}>
                                {editMode && this.props.isDDB ?
                                    <UserFieldElement
                                        dataType={UserFieldDataType.int}
                                        placeholder=""
                                        className="field-1 very-small-field"
                                        containerClassName="display-inline-block"
                                        name="SportDdB"
                                        id="SportDdB"
                                        value={this.state.SportDdB}
                                        autoCheckErrors={true}
                                        required={false}
                                        hideErrWhenFocused={true}
                                        hideErrUntilFocused={true}
                                        onChange={this.onStandardFieldChange}
                                        ref={instance => { this.fields[3] = instance; }}
                                    />
                                    : <span className="value-text">{this.props.isDDB ? this.state.SportDdB : this.props.admin.generalSection.Markering.SportDdB}</span>}
                            </td>
                            <td className={"data-cell"}>
                                {editMode && !this.props.isClub ?
                                    <UserFieldElement
                                        dataType={UserFieldDataType.int}
                                        placeholder=""
                                        className="field-1 very-small-field"
                                        containerClassName="display-inline-block"
                                        name="SportSektion"
                                        id="SportSektion"
                                        value={this.state.SportSektion}
                                        autoCheckErrors={true}
                                        required={false}
                                        hideErrWhenFocused={true}
                                        hideErrUntilFocused={true}
                                        onChange={this.onStandardFieldChange}
                                        ref={instance => { this.fields[4] = instance; }}
                                    />
                                    : <span className="value-text">{!this.props.isClub ? this.state.SportSektion : this.props.section.Sektion.Markering === null ? this.props.admin.generalSection.Markering.SportSektion : this.props.section.Sektion.Markering.SportSektion}</span>}
                            </td>
                            {this.props.isClub ?
                                <td className={"data-cell"}>
                                    {editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.int}
                                            placeholder=""
                                            className="field-1 very-small-field"
                                            containerClassName="display-inline-block"
                                            name="SportForening"
                                            id="SportForening"
                                            value={this.state.SportForening}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[5] = instance; }}
                                        />
                                        : <span className="value-text">{this.state.SportForening}</span>}
                                </td> : null
                            }
                        </tr>

                        <tr>
                            <td className={"label-cell"}></td>
                            <td className={"label-cell"}><span className="label-text"><label htmlFor="MaxDM_marathon">Marathon</label></span></td>
                            <td className={"label-cell"}><span className="label-text"><label htmlFor="MaxDM_lang">Lang</label></span></td>
                            <td className={"label-cell"}><span className="label-text"><label htmlFor="MaxDM_mellem">Mellem</label></span></td>
                            <td className={"label-cell"}></td>
                        </tr>
                        <tr className="normal-row">
                            <td className={"data-cell topic-cell"}><span className="label-text"><label>Antal DM duer for:</label></span></td>
                            <td className={"data-cell"}>
                                {editMode && this.props.isDDB ?
                                    <UserFieldElement
                                        dataType={UserFieldDataType.int}
                                        placeholder=""
                                        className="field-1 very-small-field"
                                        containerClassName="display-inline-block"
                                        name="MaxDM_marathon"
                                        id="MaxDM_marathon"
                                        value={this.state.MaxDM_marathon}
                                        autoCheckErrors={true}
                                        required={false}
                                        hideErrWhenFocused={true}
                                        hideErrUntilFocused={true}
                                        onChange={this.onStandardFieldChange}
                                        ref={instance => { this.fields[6] = instance; }}
                                    />
                                    : <span className="value-text">{this.props.isDDB ? this.state.MaxDM_marathon : this.props.admin.generalSection.Markering.MaxDM_marathon}</span>}
                            </td>
                            <td className={"data-cell"}>
                                {editMode && this.props.isDDB ?
                                    <UserFieldElement
                                        dataType={UserFieldDataType.int}
                                        placeholder=""
                                        className="field-1 very-small-field"
                                        containerClassName="display-inline-block"
                                        name="MaxDM_lang"
                                        id="MaxDM_lang"
                                        value={this.state.MaxDM_lang}
                                        autoCheckErrors={true}
                                        required={false}
                                        hideErrWhenFocused={true}
                                        hideErrUntilFocused={true}
                                        onChange={this.onStandardFieldChange}
                                        ref={instance => { this.fields[7] = instance; }}
                                    />
                                    : <span className="value-text">{this.props.isDDB ? this.state.MaxDM_lang : this.props.admin.generalSection.Markering.MaxDM_lang}</span>}
                            </td>
                            <td className={"data-cell"}>
                                {editMode && this.props.isDDB ?
                                    <UserFieldElement
                                        dataType={UserFieldDataType.int}
                                        placeholder=""
                                        className="field-1 very-small-field"
                                        containerClassName="display-inline-block"
                                        name="MaxDM_mellem"
                                        id="MaxDM_mellem"
                                        value={this.state.MaxDM_mellem}
                                        autoCheckErrors={true}
                                        required={false}
                                        hideErrWhenFocused={true}
                                        hideErrUntilFocused={true}
                                        onChange={this.onStandardFieldChange}
                                        ref={instance => { this.fields[8] = instance; }}
                                    />
                                    : <span className="value-text">{this.props.isDDB ? this.state.MaxDM_mellem : this.props.admin.generalSection.Markering.MaxDM_mellem}</span>}
                            </td>
                            <td className={"label-cell"}></td>
                        </tr>

                        <tr>
                            <td className={"label-cell"}></td>
                            <td className={"label-cell"}></td>
                            <td className={"label-cell"}><span className="label-text"><label htmlFor="Hastighed9192">Lang</label></span></td>
                            <td className={"label-cell"}><span className="label-text"><label htmlFor="HastighedAndre">Mellem</label></span></td>
                            <td className={"label-cell"}></td>
                        </tr>
                        <tr className="normal-row">
                            <td className={"data-cell topic-cell"}><span className="label-text"><label>Min. hastigheder for duer til beregning:</label></span></td>
                            <td className={"label-cell"}></td>
                            <td className={"data-cell"}>
                                {editMode && !this.props.isClub ?
                                    <UserFieldElement
                                        dataType={UserFieldDataType.float}
                                        placeholder=""
                                        className="field-1 small-field"
                                        containerClassName="display-inline-block"
                                        name="Hastighed9192"
                                        id="Hastighed9192"
                                        value={this.state.Hastighed9192}
                                        autoCheckErrors={true}
                                        required={false}
                                        hideErrWhenFocused={true}
                                        hideErrUntilFocused={true}
                                        onChange={this.onStandardFieldChange}
                                        ref={instance => { this.fields[9] = instance; }}
                                    />
                                    : <span className="value-text">{!this.props.isClub ? this.state.Hastighed9192 : this.props.admin.generalSection.Markering.Hastighed9192.toString().replace(".", ",")}</span>}
                            </td>
                            <td className={"data-cell"}>
                                {editMode && !this.props.isClub ?
                                    <UserFieldElement
                                        dataType={UserFieldDataType.float}
                                        placeholder=""
                                        className="field-1 small-field"
                                        containerClassName="display-inline-block"
                                        name="HastighedAndre"
                                        id="HastighedAndre"
                                        value={this.state.HastighedAndre}
                                        autoCheckErrors={true}
                                        required={false}
                                        hideErrWhenFocused={true}
                                        hideErrUntilFocused={true}
                                        onChange={this.onStandardFieldChange}
                                        ref={instance => { this.fields[10] = instance; }}
                                    />
                                    : <span className="value-text">{!this.props.isClub ? this.state.HastighedAndre : this.props.admin.generalSection.Markering.HastighedAndre.toString().replace(".", ",")}</span>}
                            </td>

                            <td className={"label-cell"}></td>
                        </tr>
                        {this.props.isDDB ?
                            <tr className="normal-row">
                                <td className={"data-cell topic-cell"}><span className="label-text"><label>Max. antal sekunder mellem registreringer:</label></span></td>
                                <td className={"label-cell"}></td>
                                <td className={"data-cell"}>
                                    {editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.int}
                                            placeholder=""
                                            className="field-1 small-field"
                                            containerClassName="display-inline-block"
                                            name="MaxRegTidDiff"
                                            id="MaxRegTidDiff"
                                            value={this.state.MaxRegTidDiff}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[11] = instance; }}
                                        />
                                        : <span className="value-text">{this.props.isDDB ? this.state.MaxRegTidDiff : this.props.admin.generalSection.Markering.MaxRegTidDiff}</span>}
                                </td>
                                <td className={"label-cell"}></td>
                                <td className={"label-cell"}></td>
                            </tr> : null
                        }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="bottom-content">
                <div className="block-content">
                </div>
            </div>
        </div>

    }
}

const mapStateToProps = (state) => ({
    admin: {
        generalSection: state.admin.generalSection
    }
});

export default connect(mapStateToProps, null, null, {withRef: true})(SettingsMarkings);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/settings/subPages/SettingsMarkings.js